var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7566 24.0691H19.5493V22.0327H12.4657V24.0691H11.2438C10.9093 24.0691 10.6329 24.3454 10.6329 24.68C10.6329 25.0145 10.9093 25.2909 11.2438 25.2909H20.7566C21.0911 25.2909 21.3675 25.0145 21.3675 24.68C21.3675 24.3454 21.0911 24.0691 20.7566 24.0691Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4838 6.09094H6.51648C6.00739 6.09094 5.58557 6.51276 5.58557 7.02185V19.88C5.58557 20.3891 6.00739 20.8109 6.51648 20.8109H6.80739H25.1928H25.4838C25.9928 20.8109 26.4147 20.3891 26.4147 19.88V7.02185C26.4147 6.49822 25.9928 6.09094 25.4838 6.09094ZM14.9092 11.8946H13.4692V16.2146H12.2474V11.8946H10.8074V10.6728H14.9092V11.8946ZM18.6619 16.3309L16.1165 11.1237L17.2074 10.5855L18.6474 13.5528L20.0874 10.5855L21.1783 11.1237L18.6619 16.3309Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIcon);
export default __webpack_public_path__ + "static/media/tv_icon.0d1a3316068ba3cba7b1bf973ba9e8c0.svg";
export { ForwardRef as ReactComponent };